import { useEffect, useCallback, useRef } from 'react';
import { useLocation } from 'react-router-dom';

const TIKTOK_PIXEL_ID = 'D9EEA5RC77U2EG6DN200';

export function useTikTokPixel() {
  const location = useLocation();
  const prevPathRef = useRef('');

  useEffect(() => {
    const path = location.pathname;
    if (path === prevPathRef.current) return;
    prevPathRef.current = path;

    if (typeof window.ttq === 'undefined' || !window.ttq) return;

    try {
      window.ttq.page();
    } catch (e) {
      console.warn('[TikTok Pixel] page() failed:', e);
    }
  }, [location.pathname]);

  const trackEvent = useCallback((event, properties) => {
    if (typeof window.ttq === 'undefined' || !window.ttq) {
      console.warn('[TikTok Pixel] not loaded');
      return;
    }
    try {
      window.ttq.track(event, properties || {});
    } catch (e) {
      console.warn(`[TikTok Pixel] track(${event}) failed:`, e);
    }
  }, []);

  return { trackEvent, pixelId: TIKTOK_PIXEL_ID };
}

export default useTikTokPixel;
